import React, { CSSProperties, useEffect } from 'react';
import { Heart } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';
import SmallLoader from 'components/SmallLoader/SmallLoader';
import { useUpdateFavoriteModel } from './hooks';
import { LoaderWrapper, StyledIcon } from './FavoriteButton.styled';

interface FavoriteButtonProps {
  favoriteIconStyle: CSSProperties;
  modelId: number;
  initialIsFavorite: boolean;
  onToggleSuccess?: () => void;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({
  favoriteIconStyle,
  modelId,
  initialIsFavorite,
  onToggleSuccess,
}) => {
  const {
    mutate: updateFavoriteModel,
    isLoading: isUpdatingFavoriteModel,
    isSuccess: isUpdateFavoriteModelSuccess,
  } = useUpdateFavoriteModel();

  useEffect(() => {
    if (isUpdateFavoriteModelSuccess) {
      onToggleSuccess?.();
    }
  }, [isUpdateFavoriteModelSuccess]);

  if (isUpdatingFavoriteModel) {
    return (
      <LoaderWrapper favoriteIconStyle={favoriteIconStyle}>
        <SmallLoader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledIcon
      favoriteIconStyle={favoriteIconStyle}
      size={26}
      svg={Heart}
      color={COLORS.GREEN}
      weight={initialIsFavorite ? 'fill' : 'light'}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        updateFavoriteModel({
          modelId,
          isFavorite: !initialIsFavorite,
        });
      }}
    />
  );
};
